<div>
    <div class="modal-header customBlueHeader">
        <p class="modal-title">Print Document</p>
        <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body customModalBody" *ngIf="serviceTypeID == 1">
        <h5>Doctor Consultation</h5>
        <div class="div">
            <span>Note Print</span>
            <a (click)="downloadDocument('prescription',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
    </div>
    <div class="modal-body customModalBody" *ngIf="serviceTypeID == 2">
        <h5>Medicines</h5>
        <div class="div">
            <span>Prescription Print</span>
            <a (click)="downloadDocument('prescription',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
        <div class="div">
            <span>Drug Request</span>
            <a (click)="downloadDocument('invoice',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
    </div>
    <div class="modal-body customModalBody" *ngIf="serviceTypeID == 5">
        <h5>Care at Home</h5>
        <div class="div">
            <span>Note Print</span>
            <a (click)="downloadDocument('prescription',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
        <div class="div">
            <span>Home Care Bill</span>
            <a (click)="downloadDocument('invoice',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
    </div>
    <div class="modal-body customModalBody" *ngIf="serviceTypeID == 30">
        <h5>Assessment Order</h5>
        <div class="div">
            <span>Note Print</span>
            <a (click)="downloadDocument('prescription',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
        <div class="div" *ngIf="serviceSubTypeID == 103 || serviceSubTypeID == 201">
            <span> Invoice Print</span>
            <a (click)="downloadDocument('invoice',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
        <div class="div" *ngIf="serviceSubTypeID != 103 && serviceSubTypeID != 201">
            <span>Home Care Bill </span>
            <a (click)="downloadDocument('invoice',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
    </div>
    <div class="modal-body customModalBody" *ngIf="serviceTypeID == 4">
        <h5>Radiology</h5>
        <div class="div">
            <span>Prescription Print</span>
            <a (click)="downloadDocument('prescription',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
        <div class="div">
            <span>Invoice Print</span>
            <a (click)="downloadDocument('invoice',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
    </div>
 
    <div class="modal-body customModalBody" *ngIf="serviceTypeID != 4 && serviceTypeID != 1 && serviceTypeID != 2 && serviceTypeID != 5 && serviceTypeID != 30">
        <h5>Business Name</h5>
        <div class="div">
            <span>Prescription Print</span>
            <a (click)="downloadDocument('prescription',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
        <div class="div">
            <span>Invoice Print</span>
            <a (click)="downloadDocument('invoice',orderDetailsData)"><img class="exitImg" src="./assets/img/download.png"></a>
        </div>
    </div>
 
    <div class="pull-Right modal-footer">
        <button type="button" class="btn closeGreenBordBtn" (click)="close()">Close</button>
    </div>
 
</div>